import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { Icon } from "@/domain/Breeds/breeds.types";

import Accordion from "@/components/shared/Accordion";
import type { AccordionsSectionProps } from "./accordionsTypes";

import s from "./accordionsSection.module.scss";

import {
  faBook,
  faBrain,
  faBlockQuestion,
  faHandHoldingHeart,
  faMeat,
  faPumpSoap,
  faSyringe,
  faBone,
  faStethoscope,
  IconDefinition
} from "@fortawesome/pro-solid-svg-icons";

const AccordionsSection = ({ accordions }: AccordionsSectionProps) => {
  const iconMap: Record<Icon, IconDefinition> = {
    historia: faBook,
    comportamento: faBrain,
    curiosidades: faBlockQuestion,
    cuidados: faHandHoldingHeart,
    alimentação: faMeat,
    higiene: faPumpSoap,
    saúde: faStethoscope,
    vacinação: faSyringe,
    adestramento: faBone
  };

  return (
    <>
      {accordions.map((accordion, index) => {
        const icon =
          accordion.icons &&
          iconMap[accordion.icons as Icon] &&
          iconMap[accordion.icons as Icon];

        return (
          <Accordion
            key={index}
            id={`panel-${index}`}
            title={accordion.question}
            showAccordion={accordions.length > 1}
            icon={
              icon ? (
                <FontAwesomeIcon
                  icon={icon}
                  color="var(--token-cobasi-colors-turquoise-primary)"
                />
              ) : null
            }
          >
            <hr className="divider" />
            <div
              className={`body-text-sm ${s.content}`}
              dangerouslySetInnerHTML={{ __html: accordion.answer }}
            />
            {accordion.image && (
              <img
                src={accordion.image}
                alt={accordion.question}
                className={s.image}
              />
            )}
          </Accordion>
        );
      })}
    </>
  );
};

export default AccordionsSection;
